import React, {useRef, useState} from 'react'
import {Button, Input, NavDivider, Navigation, TOAST} from "retro/index";
import {post} from "App/Network/Axios";


export default function CancelInvoiceController() {
	const TRANSID = useRef()
	const REMARKS = useRef()
    const [loading,setLoading] = useState(false)
	return (
		<div>
            <Navigation backUrl={'back'} title="CPL TO CTPL PVT LTD" />
            <NavDivider />
			<Input
				ref={TRANSID}
				type="text"
				label="Transaction Id"
				placeholder="Transaction Id"
			/>
			<Input
				ref={REMARKS}
				type="text"
				label="Remarks"
				placeholder="Remarks"
			/>
            <Button
                onClick={()=>{
					let transId = TRANSID.current.value;
					let remarks = REMARKS.current.value;
					if(!transId){
						TOAST.error("Enter a valid trans id")
						return
					}
					setLoading(true)
					post(`/meta/${transId}/pvtToPackage`,{
						remarks
					},(e,r)=>{
						setLoading(false)
						if(r){
							TOAST.success("Regeneration done successfully")
							TRANSID.current.value = ""
							REMARKS.current.value = ""
						}else{
							TOAST.handleError(e)
						}
					})
                }}
                className="btn-black btn-primary"
                margin="pd2 mt4"
                loading={loading}
            >
                Regenerate
            </Button>
		</div>
	)
}
